import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        showFilter: '=',
        sites: '='
    },
    template: `
        <div class="table-filters">
                <form ng-submit="vm.applyFilter()" class="form form-filter"  ng-if="vm.showFilter">
                    <div class="fields">
                        <div class="row row-md">
                            <label class="label">{{ 'filter.Course' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.filter.courseName" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="row row-separated">
                            <label class="label">{{ 'filter.Status' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.multiFilter.statuses.options"
                                    selected-model="vm.multiFilter.statuses.model"
                                    extra-settings="vm.multiFilter.statuses.settings"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                        <div class="row row-md">
                            <label class="label">{{ 'filter.Employee' | translate }}</label>
                            <div class="items">
                                <autocomplete
                                    label-attribute="'displayName'"
                                    selected-item="vm.selectedEmployee"
                                    ng-model="vm.filter.userId"
                                    value-attribute="'id'"
                                    placeholder="vm.$translate.instant('filter.Find an employee')"
                                    query="vm.queryUsers(input)"
                                />
                            </div>
                        </div>
                        <div class="row row-separated">
                            <label class="label">{{ 'filter.Request type' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.multiFilter.requestTypes.options"
                                    selected-model="vm.multiFilter.requestTypes.model"
                                    extra-settings="vm.multiFilter.requestTypes.settings"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>

                    </div>
                    <ul class="actions01">
                        <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                        <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                    </ul>
                </form>
        </div>
    `
})
export default class {
    constructor (lodash, FilterService, COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM, UserResource, $translate, ROLE_CODE_ENUM,
            COURSE_EXTERNAL_PARTICIPATION_REQUEST_TYPE_ENUM) {
        this.lodash = lodash;
        this.FilterService = FilterService;
        this.UserResource = UserResource;
        this.$translate = $translate;
        this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM = COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM;
        this.COURSE_EXTERNAL_PARTICIPATION_REQUEST_TYPE_ENUM = COURSE_EXTERNAL_PARTICIPATION_REQUEST_TYPE_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
    }

    $onInit () {
        this.initFilters();
        this.defaultFilter = angular.copy(this.filter);
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    queryUsers (input) {
        let siteIds = this.sites.map(site => site.id);
        if (!siteIds.length) {
            siteIds = [-1];
        }
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            name: input,
            pageSize: 0,
            siteIds,
            privilegesCheck: false
        };

        return this.UserResource.getUsers({}, params).$promise;
    }

    applyFilter () {
        if (this.multiFilter.statuses.model.length) {
            this.filter = this.lodash.assign(this.filter, { 'statuses[]': this.multiFilter.statuses.model.map(status => status.value) });
            this.filter = this.lodash.assign(this.filter, { 'requestTypes[]': this.multiFilter.requestTypes.model.map(type => type.value) });
        }

        this.list.fetch(this.filter);
    }

    initFilters () {
        this.filter = {
            expand: 'user,courseDates,firstTime,lastTime', isAdmin: true
        };

        this.filterTranslations = this.FilterService.getTranslations();
        const statusOptions = [
            {
                value: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.IN_CONFIRMATION,
                label: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS.IN_CONFIRMATION
            },
            {
                value: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED,
                label: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS.CONFIRMED
            },
            {
                value: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.DECLINED,
                label: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS.DECLINED
            },
            {
                value: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.WAITING_FOR_DIRECT_MANAGER,
                label: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS.WAITING_FOR_DIRECT_MANAGER
            },
            {
                value: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED_BY_DIRECT_MANAGER,
                label: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS.CONFIRMED_BY_DIRECT_MANAGER
            },
            {
                value: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.NEED_DETAILS,
                label: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS.NEED_DETAILS
            },
            {
                value: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CANCELLED,
                label: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS.CANCELLED
            }
        ];

        const requestTypeOptions = [
            {
                value: this.COURSE_EXTERNAL_PARTICIPATION_REQUEST_TYPE_ENUM.KEYS.SPECIFIC,
                label: this.COURSE_EXTERNAL_PARTICIPATION_REQUEST_TYPE_ENUM.LABELS.SPECIFIC
            },
            {
                value: this.COURSE_EXTERNAL_PARTICIPATION_REQUEST_TYPE_ENUM.KEYS.SIMPLE,
                label: this.COURSE_EXTERNAL_PARTICIPATION_REQUEST_TYPE_ENUM.LABELS.SIMPLE
            }
        ];

        const statusOptionsSelected = this.lodash.map(statusOptions, option => option);
        const requestTypeOptionsSelected = this.lodash.map(requestTypeOptions, option => option);
        this.multiFilter = {
            statuses: {
                model: statusOptionsSelected,
                options: statusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: itemText => itemText
                }
            },
            requestTypes: {
                model: requestTypeOptionsSelected,
                options: requestTypeOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: itemText => itemText
                }
            }
        };
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/participations/filter/index.js